import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import LoginForm1 from './LoginForm1'

// Functional component for the Startup login page.
const LoginStartup = () => {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch({
      type: 'TOGGLE_STARTUP_BUTTON',
    })
  }, [])
  return <LoginForm1 pageType={'startup'} />
}

export default LoginStartup
